import { render, staticRenderFns } from "./sector-indices.vue?vue&type=template&id=24de06c2"
import script from "./sector-indices.vue?vue&type=script&lang=js"
export * from "./sector-indices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./sector-indices.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {DateRange: require('/vercel/path0/components/ui/DateRange.vue').default,HorizontalLoader: require('/vercel/path0/components/ui/HorizontalLoader.vue').default,PriceChange: require('/vercel/path0/components/micro/PriceChange.vue').default})
